import BaseChange from "./BaseChange"

export default class LoadingMap extends BaseChange {
  constructor() {
    super()
    this.setMessage({ message: "Loading map", hide: true })
    this.type = "loadingMap"
  }

}
